'use client';

import { Typography, Button, Stack } from '@mui/material';
import Link from 'next/link';
import { InvestStepItemProps } from '@/components/item/InvestStepItem';
import AnimateStepper from '@/components/StepperSlider';
import { IconSvg } from '@/components/Icon';
import { ROUTES } from '@/utils/constants';
import Section from '@/components/Section';
import Container from '@/components/layout/Container';
import { useSession } from '@/utils/auth/useSession';
const texts = {
  title: 'مراحل سرمایه‌گذاری در زیما',
  subTitle: 'برای شروع سرمایه‌گذاری کافیست مراحل زیر را انجام دهید:',
  btnTitle: 'ورود / ثبت‌نام'
};
const items: InvestStepItemProps[] = [{
  title: '۱. ثبت‌نام در زیما',
  description: 'در قدم اول ثبت‌نام خود را در زیما انجام داده و حساب کاربری ایجاد کنید',
  icon: <IconSvg component='Signup' />
}, {
  title: '۲. احراز هویت سجام',
  description: 'در سایت سجام ثبت‌نام و احراز هویت کنید. <br/> سپس کدبورسی خود را دریافت و در حساب کاربری زیما وارد کنید.',
  icon: <IconSvg component='Sejam' />
}, {
  title: '۳. مقایسه و انتخاب طرح',
  description: 'طرح‌های سرمایه‌گذاری را در زیما بررسی، مقایسه و انتخاب کنید.',
  icon: <IconSvg component='Compare' />
}, {
  title: '۴. شروع سرمایه‌گذاری',
  description: 'با پرداخت و سرمایه‌گذاری در طرح انتخابی‌تان، گواهی فرابورس برای شما صادر خواهد شد.',
  icon: <IconSvg component='InvestBond' />
}];
const InvestSteps = (): JSX.Element => {
  const {
    user
  } = useSession();
  return <Container data-sentry-element="Container" data-sentry-component="InvestSteps" data-sentry-source-file="InvestSteps.tsx">
      <Section sx={{
      py: 'var(--spacing_l)'
    }} data-sentry-element="Section" data-sentry-source-file="InvestSteps.tsx">
        <Stack justifyContent='center' alignItems='center' gap='var(--spacing_m)' data-sentry-element="Stack" data-sentry-source-file="InvestSteps.tsx">
          <Typography variant='titleStrong__Wallfund' component='h2' data-sentry-element="Typography" data-sentry-source-file="InvestSteps.tsx">
            {texts.title}
          </Typography>
          <Typography typography={{
          xs: 'bodyRegular__Wallfund',
          md: 'bodyLargeRegular__Wallfund'
        }} color='text.text2' textAlign='center' data-sentry-element="Typography" data-sentry-source-file="InvestSteps.tsx">
            {texts.subTitle}
          </Typography>
        </Stack>

        <AnimateStepper items={items} data-sentry-element="AnimateStepper" data-sentry-source-file="InvestSteps.tsx" />

        <Stack direction='row' justifyContent='center' data-sentry-element="Stack" data-sentry-source-file="InvestSteps.tsx">
          {user ? <Button LinkComponent={Link} variant='contained' href={ROUTES.crowdfundingPlan.href} title={ROUTES.crowdfundingPlan.title} size='large'>
              {ROUTES.crowdfundingPlan.name}
            </Button> : <Button LinkComponent={Link} variant='contained' href={ROUTES.login.href} title={ROUTES.login.title} size='large'>
              {texts.btnTitle}
            </Button>}
        </Stack>
      </Section>
    </Container>;
};
export default InvestSteps;